/**
 * Het land dat de bezoeker bij het afrekenen heeft ingevuld, uit de bewaarde checkout-gegevens.
 *
 * Waarom: de winkelwagen rekende altijd met het Nederlandse tarief. Voor een Belgische klant met
 * alléén artikelen klopte het bedrag daar dus niet — er is een apart (hoger) BE-pakkettarief — en
 * pas op de afrekenpagina sprong het omhoog. Zodra het land bekend is, rekent de winkelwagen er
 * meteen mee. Nog niets ingevuld → NL, net als voorheen.
 */
export const CHECKOUT_SAVE_KEY = "glastotaal.checkout.v1";
const SAVE_KEY = CHECKOUT_SAVE_KEY;

export function savedShippingCountry(): "NL" | "BE" {
  try {
    const raw = localStorage.getItem(SAVE_KEY);
    if (!raw) return "NL";
    const p = JSON.parse(raw) as { shipping?: { country?: unknown } };
    return p.shipping?.country === "BE" ? "BE" : "NL";
  } catch {
    return "NL"; // kapotte/geblokkeerde storage mag de winkelwagen niet slopen
  }
}
